var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("vue-ueditor-wrap", {
    ref: "ueditor",
    attrs: { config: _vm.editorConfig, destroy: true, init: _vm.init },
    model: {
      value: _vm.currentValue,
      callback: function($$v) {
        _vm.currentValue = $$v
      },
      expression: "currentValue"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }